import React, { memo, useMemo } from "react";
import { FaIcon } from "../Icons.jsx";

export const ChangeTrackingCellRenderer = memo(({ value = null, data = {} }) => {
  if (!value) return null;
  
  const { change, timestamp } = value;

  if (!timestamp) return null;

  const icon = useMemo(() => {
    if (change > 0) {
      return <FaIcon type='arrow-up' className='text-success' />
    } else if (change < 0) {
      return <FaIcon type='arrow-down' className='text-danger' />
    }
    return <FaIcon type='arrow-right' className='text-muted' />;
  }, [change]);

  return (
    <div className='change-tracking-cell'>
      {timestamp} {icon}
    </div>
  );
});